<template>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline" style="width:94%;text-align:start">Create Folder</span>
            <div style="position: relative;inset-inline-start:4%;bottom: 3px;"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30"  @click="closeDialog()" fill="currentColor" class="bi bi-x close-icon" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
            </svg></div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <div class="modal-body">
                <input type="text" ref="folderNameField" v-if="show" class="bg-transparent border rounded text-light form-control input-fields" v-model="folderName" @keyup.enter="createFolderAction()">
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions class="primary-btn-style">
            <button @click="closeDialog()" data-dismiss="modal" class="btn btn-outline-secondary mr-2">Cancel</button>
            <button type="button" class="btn btn-outline-primary ml-1" @click="createFolderAction()">
            Save
          </button>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import Utils from "../../components.utils.js";

export default {
  props:["folderInfoToGetCurrentPath","isFolderExists"],
  data: () => ({
    dialog: true,
    folderName: null,
    folderInfo: {},
    show:false,
  }),
  computed:{
    ...mapGetters("files",["getfolderInfoToGetCurrentPath"]),
  },
  methods:{
      closeDialog(){
          this.$emit("close");
      },
      isFolderExistsCheck(path){
        let payload = { params: {} };
        payload.params.browse = true;
        payload.params._id = this.getfolderInfoToGetCurrentPath._id;
        payload.params.file_type = 'folder';
        this.getAllFilesFromServer(payload).then((data) => {
        let folderinfo = data.files.filter((file_)=>file_.path==path);
          if(folderinfo.length != 0){
            return true
          }else{
            return false
          }
        });
      },
      createFolderAction(){
          this.folderInfo.element_type = "folder";
          this.folderInfo.job_name = "CreateFolder";
          const validation = Utils.isSafeFolderOrFileName(this.folderName);
          if (!validation.valid) {
            alert(validation.message);
            this.$refs.folderNameField.focus();
            return;
          }
          if(this.folderName == null || this.folderName.trim().length == 0){
             alert("Folder with empty name is not supported.\nPlease enter valid folder name.");
             this.$refs.folderNameField.focus();
             return false;
          }else if(Object.keys(this.getfolderInfoToGetCurrentPath.folderInfo).includes('path') && this.getfolderInfoToGetCurrentPath.folderInfo.path != undefined){
            this.folderInfo.path = this.getfolderInfoToGetCurrentPath.folderInfo.path + "/" + this.folderName.trim();
          }else{
            this.folderInfo.path = "share://" + this.getfolderInfoToGetCurrentPath.bin_id + "/" + this.folderName.trim();
          }

          // let payload = { params: {} };
          // payload.params.browse = true;
          // payload.params._id = this.getfolderInfoToGetCurrentPath._id;
          // payload.params.file_type = 'folder';
          // this.getAllFilesFromServer(payload).then((data) => {
          // let folderinfo = data.files.filter((file_)=>file_.path==this.folderInfo.path);
          //   if(folderinfo.length != 0){
          //     this.$toast.error(`${this.folderName} folder already exists!!!`);
          //     return false
          //   }
          // });
          
          this.createFolder(this.folderInfo).then((data)=>{
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.$toast.success(data.message);
                    this.closeDialog();
                } else {
                    this.$toast.error(data.message);
                }
          });
        this.closeDialog();
      },
    ...mapActions("actions", ["createFolder"]),
    ...mapActions("files", ["getAllFilesFromServer"]),
  },
  watch: {
    'show': function (val) {
      if (val) {
          this.$nextTick(() => {
          this.$refs.folderNameField.focus()
        })
      }
    }
  },
  mounted(){
    setTimeout(() => {
      this.show = true;
    }, 200)
  },
  created(){
  }
}
</script>

<style lang="scss" scoped>
  $border-color: 1px solid #4a4a4a;
  $border-color-only:#4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $danger-color: #dc3545 !important;
  $input-field-height:38px;
  $none-text-color:#4f4f4f;
  $input-field-padding:.375rem 10px;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $tags-background-color:#282d31;
  $tags-border-color:#363636;
  $metadata-border-color-on-hover: #5a5a5a;
  $secondary-border-color: 1px solid #2b2b2b;
  $active-green-color:#28a745;
  $svg-color:#666;
  $learn-about-text-color-hover:#b7b327;
  $active-green-icon-color: #00ff3a;
  $learn-about-text-color:#9a9620;
  $icon-hover:#2c3339;

::v-deep{
    .v-card__title, .v-card__actions{
        background: $secondary-background-color !important;
        padding:8px;
        border-bottom: $secondary-border-color;
    }
    .v-card__text{
        background: $primary-background !important;
    }

    .v-card__actions{
        border-top: $secondary-border-color;
    }
    .save-btn.v-btn--outlined {
        border: thin solid #007bff;
    }

    .theme--dark.v-btn.v-btn--outlined.v-btn--text {
        border-color: #007bff;
    }

    .v-card.v-sheet.theme--dark{
        border: $secondary-border-color;
    }

    .v-text-field__slot{
        margin-inline-start:-10px;
    }
     .v-text-field {
        input {
                margin-inline-start: 12px;
                margin-top: 16px;
                color:$text-color
        }
     }
}

svg{
    fill:$svg-color;
}
.primary-btn-style {
  justify-content: flex-end;
  margin-top: 1%;
  height:55px;
  button {
    height: 35px;
    width: 70px;
    border-radius: 5px;
    font-size:14px;
  }
}
.secondary-btn-style:hover {
    text-decoration: underline;
}

.input-fields {
  border: none !important;
  border-bottom: 1px solid #007bff !important;
  height:30px;
}

.input-fields:focus {
  outline: unset;
  box-shadow:none;
}
.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
  fill:$text-color;
}
</style>